export const SearchPlaceholder = "LzD7wb";
export const SearchAriaLabel = "$LUmge";
export const SearchWithCopilotPlaceholder = "TS_yvc";
export default {SearchPlaceholder,SearchAriaLabel,SearchWithCopilotPlaceholder};